// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__aNTiR","btn":"styles_btn__sTrba","arrow":"styles_arrow__fPSQG","activeBtn":"styles_activeBtn__rozFF"};